// MC4WP plugin - AJAX submit

export default () => {
    const nodeSelectors = {
        container: '.mc4wp-form',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        const mcForms = jQuery(nodeSelectors.container);

        mcForms.each(function () {
            jQuery(this).append('<div class="spinner-holder"><div class="c-spinner"></div></div>')
        })

        mcForms.on('submit', function (e) {
            e.preventDefault()
            let formID = jQuery(this).attr('id')
            let form = jQuery('#' + formID)
            let formSpinner = form.find('.spinner-holder')
            formSpinner.fadeIn();

            jQuery.ajax({
                url: window.location.href,
                data: form.serialize(),
                type: "POST",
                success: function (data) {
                    let mcResponse = form.find('.mc4wp-response')
                    let mcAlert = jQuery(data).find('#' + formID).find(".mc4wp-alert")
                    mcResponse.html(mcAlert)

                    if( mcAlert.hasClass('mc4wp-success')) {
                        form.trigger("reset")
                    }
                },
                error: function (e) {
                    console.log(e)
                },
                complete: function () {
                    formSpinner.fadeOut();
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}